import { Controller, Menu } from '@tencent/workbench';
import { MENU_ITEMS, config } from './config';
import { CopyLinkFeature } from '@framework/workbench/ui/copy-link/copy-link-feature';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TitlebarFileMenuConfig, ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    menuItems: MENU_ITEMS,
})
export class CopyLinkController {
    constructor(private readonly feature: CopyLinkFeature) {
    }

    @Menu(config.id, 'onClick')
    public onClick() {
        this.feature.callback();
    }

    @Menu(config.id, 'shouldHide')
    public handleHide(): boolean {
        const isSimplifyMode = (appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false);
        return !isSimplifyMode || !appConfigInstance.getConfig(ToolbarFileMenuConfig.copyLink as any);
    }
}
